

















import { defineComponent, toRef } from '@nuxtjs/composition-api';
import {
  PAGINATION_DEFAULT_RESULTS_LIMIT,
  RATING_REVIEWS_SECTION_SELECTOR,
  REVIEW_ID,
} from '~/constants/pagination';
import { useReviewExtended, useAnchorNavigation } from '~/composables';
import LoadMorePagination from '@/components/molecules/Pagination/LoadMorePagination.vue';
import CustomPagination from '@/components/molecules/Pagination/CustomPagination.vue';
import type { UpdatePaginationPageParams } from '~/types/pagination';
import { scrollToSection } from '~/helpers/scroll/scrollToSection';

export default defineComponent({
  name: 'PaginationReviews',
  components: {
    LoadMorePagination,
    CustomPagination,
  },
  props: {
    totalResultsAmount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: PAGINATION_DEFAULT_RESULTS_LIMIT,
    },
    productId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const productIdRef = toRef(props, 'productId');

    const {
      search: searchReviews,
    } = useReviewExtended(productIdRef);

    const { stickyAnchorNavHeight } = useAnchorNavigation();

    const onPageChange = (pageChangeParams: UpdatePaginationPageParams) => {
      scrollToSection(RATING_REVIEWS_SECTION_SELECTOR, -stickyAnchorNavHeight.value);
      updatePage(pageChangeParams);
    };

    const onLoadMore = async (pageChangeParams: UpdatePaginationPageParams) => {
      await updatePage(pageChangeParams);
      scrollToSection(`#${REVIEW_ID}-${pageChangeParams.limit - props.perPage}`);
    };

    const updatePage = async (pageChangeParams: UpdatePaginationPageParams) => {
      await searchReviews(pageChangeParams);
    };

    return {
      onPageChange,
      onLoadMore,
      RATING_REVIEWS_SECTION_SELECTOR,
    };
  },
});
